import React from "react";
import { connect } from "react-redux";
import "./Button.scss";
import { useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

export default connect(
	(state) => ({}),
	{}
)(
	({
		icon,
		placeholder,
		label,
		className,
		onClick,
		rightIcon = faArrowRight,
		showRightIcon = false,
		disabled = false,
		iconOnly = false,
		loading = false,
	}) => {
		const { formatMessage } = useIntl();

		return (
			<div className={`flex direction-row align-items-center justify-content-center`}>
				<button
					className={`${iconOnly ? "icon-only" : "custom-button"}  ${
						disabled ? "button-disabled" : ""
					} ${className}`}
					onClick={() => {
						if (!disabled && !loading) {
							onClick();
						}
					}}
					disabled={disabled}
				>
					{loading ? (
						<div className="input-loader"></div>
					) : (
						<>
							{icon ? (
								<FontAwesomeIcon icon={icon} size="x" className={!iconOnly ? "mr-8" : ""} />
							) : (
								<></>
							)}
							{iconOnly ? <></> : <>{formatMessage({ id: `${label}` })}</>}
							{showRightIcon && <FontAwesomeIcon icon={rightIcon} size="x" className="ml-8" />}
						</>
					)}
				</button>
			</div>
		);
	}
);
